import { Suspense } from 'react';
import Loader from 'monday-ui-react-core/dist/Loader';

/**
 * Higher-order component that wraps a component with Suspense and a loading fallback
 * @param {React.Component} Component - The component to wrap
 * @param {Object} options - Optional configuration
 * @param {React.Component} options.fallback - Custom fallback component
 * @param {string} options.size - Loader size (SMALL, MEDIUM, LARGE)
 * @returns {JSX.Element} Wrapped component with Suspense
 */
export const withSuspense = (Component, options = {}) => {
  const { 
    fallback, 
    size = Loader.sizes.LARGE 
  } = options;

  const defaultFallback = (
    <div className="loader">
      <Loader size={size} />
    </div>
  );
  
  return (
    <Suspense fallback={fallback || defaultFallback}>
      {Component}
    </Suspense>
  );
};